<template>
  <span class="icon-link" @click="linkFun"> <i class="iconfont iconbj_link "></i>{{ params.value }} </span>
</template>

<script>
export default {
  name: 'iconLink',
  props: {
    params: {},
  },
  mounted() {
  },
  methods: {
    linkFun() {
      const id = this.params.data.ID.val;
      const labelName = this.params.data.BILL_TYPE.val;
      let label = '';
      let tableId = '';
      let tableName = '';
      if (labelName === t('逻辑调拨单批量导入')) { // 逻辑调拨单批量导入
        tableId = '249231153';
        tableName = 'SG_B_STO_BATCH_TRANSFER';
      } else if (labelName === t('逻辑调拨单批量导入')) { // 聚合仓调拨单
        tableId = '249231169';
        tableName = 'SG_B_SHARE_TRANSFER';
      } else if (labelName === t('聚合仓到配销仓调拨单')) { // 聚合仓到配销仓调拨单
        tableId = '249231236';
        tableName = 'SG_B_SHARE_SA_ALLOCATION_TRANSFER';
      } else if (labelName === t('配销仓调拨单')) { // 配销仓调拨单
        tableId = '249231217';
        tableName = 'SG_B_SHARE_SA_CROSS_TRANSFER';
      } else if (labelName === t('配销仓到聚合仓调拨单')) { // 配销仓到聚合仓调拨单
        tableId = '249231240';
        tableName = 'SG_B_SHARE_FROM_SA_TRANSFER';
      }
      // 跳转页面
      R3.store.commit('global/tabOpen', {
        type: 'V',
        tableName,
        label: labelName,
        tableId,
        id
      });
    },
  },
};
</script>

<style scoped lang="less">
.icon-link {
  i {
    color: #0f8ee9;
    cursor: pointer;
    font-size: 12px;
  }
}
</style>
